import type { LogoWallContent } from "../types";

export const logoWall: LogoWallContent = {
  title: "Bygget af universiteterne.",
  introLead:
    "UCloud AI er udviklet af Syddansk Universitet og integreret i den " +
    "nationale forskningsplatform UCloud. Servicen bygger videre på det " +
    "eksisterende samarbejde mellem SDU, Aarhus Universitet og Aalborg " +
    "Universitet i DeiC Interactive HPC-konsortiet og kører på Bitten i " +
    "et bæredygtigt datacenter i Sønderborg, bygget af SDU i partnerskab " +
    "med Danfoss og HPE. ",
  introStrong:
    "Europas mest anvendte nationale forskningssky, nu med suveræn " +
    "AI-inferens indbygget.",
  linkLabel: "Udforsk Interactive HPC",
  mapTitle: "Kort over Danmark",
  mapDescription:
    "Et kort over Danmark med de otte danske universiteter og Bitten-datacentret i Sønderborg.",
  mapLabelPrimary: "DANMARK / EU",
  mapLabelSecondary: "8 UNIVERSITETER · 1 NATIONAL PLATFORM",
  nodeNames: {
    aalborg: "Aalborg Universitet",
    aarhus: "Aarhus Universitet",
    sdu: "Syddansk Universitet",
    ku: "Københavns Universitet · IT-Universitetet i København · Copenhagen Business School",
    dtu: "Danmarks Tekniske Universitet",
    ruc: "Roskilde Universitet",
    bitten: "Bitten-datacentret, Sønderborg",
    gefion: "DCAI/Gefion",
  },
  logoAriaLabel: "Interactive HPC-konsortiets logoer",
  logoNames: {
    aalborg: "Aalborg Universitet",
    aarhus: "Aarhus Universitet",
    sdu: "Syddansk Universitet",
  },
  logoHrefs: {
    aalborg: "https://www.aau.dk/",
    aarhus: "https://www.au.dk/",
    sdu: "https://www.sdu.dk/",
  },
};
